import React from "react";

// Discreet laurel-wreath / crest motif in gold, echoing the flyer.
export const Laurel = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 120 200"
    className={className}
    fill="none"
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    aria-hidden="true"
  >
    <path
      d="M110 6C70 20 40 60 40 110c0 34 14 62 40 84"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    {Array.from({ length: 9 }).map((_, i) => {
      const t = i / 8;
      const y = 20 + t * 150;
      const x = 40 + Math.sin(t * Math.PI) * 34;
      const rot = -60 + t * 40;
      return (
        <g key={i} transform={`translate(${x} ${y}) rotate(${rot})`}>
          <path
            d="M0 0 C 10 -5 22 -3 30 4 C 20 8 8 7 0 0 Z"
            fill="currentColor"
            opacity="0.85"
          />
        </g>
      );
    })}
  </svg>
);

export const Crest = ({ className = "" }) => (
  <div className={`flex items-center justify-center ${className}`}>
    <Laurel className="h-full w-auto text-[var(--gold)]" />
    <Laurel className="h-full w-auto text-[var(--gold)]" flip />
  </div>
);
